import jwt from "jsonwebtoken";
import PrintTemplate from "./PrintTemplate";
import {useEffect, useState} from "react";
import FunctionsData from "../Functions/FunctionsData";
import PrintTemplateCommunity from "./PrintTemplateCommunity";

const queryString = require('query-string');
const jwtKey = process.env.REACT_APP_JWT_KEY;

/*
    This is the main component that will be used to print the voucher
    It will be used in the following pages:
    @param decoded - the decoded JWT token
    @param arr - the array of vouchers
    @param frmFn - the name of the form
    @param cid - the JWT token
    @param community - boolean value to determine if the voucher is for a community or not
 */
const ShowVoucher = ({decoded,frmFn,cid,community,outreach}) => {

    let arr = [];
    const [vet, setVets] = useState([]);

    function setData(decoded) {
        //console.log('decoded',decoded);
        FunctionsData.fetchDataGetNoLoading(
            '/api/campaign/vets/'+ decoded['vet_id'],
            setVets
        )
    }

    useEffect(() => {
        setData(decoded);
    }, []);


    for(let x in decoded['vouchers']) {
        let o = Object.values(decoded['vouchers'][x]);
        //console.log(o);
        if(o.length > 0) {
            arr.push(o);
        }
    }

    if(community) return (
        <div style={{padding:20}}>
            <PrintTemplateCommunity
                name={frmFn}
                voucher={arr}
                currentVetArr={(vet.length > 0) ? vet[0] : []}
                jwtKey={jwtKey}
                cid={cid}
                decoded={decoded}
                email={false}
                outreach={outreach}
            />
        </div>
    )

    return (
        <div style={{padding:20}}>
            <PrintTemplate
                name={frmFn}
                voucher={arr}
                currentVetArr={(vet.length > 0) ? vet[0] : []}
                jwtKey={jwtKey}
                cid={cid}
                decoded={decoded}
                email={false}
            />
        </div>
    )
}

export default function Print() {

    const parsed = queryString.parse(window.location.search);
    const hostname = window.location.hostname.toLowerCase();
    const isOutreach = hostname.includes('outreach');
    try {
        const decoded = jwt.verify(parsed.cid, jwtKey);
        //console.log(decoded);
        return (
            <ShowVoucher community={(parsed.com > 0)} outreach={isOutreach} decoded={decoded} cid={parsed.cid}/>
        )
    } catch(err) {
        return (
            <h1>Not valid</h1>
        )
    }

}
